'use strict';

/**
 * Initialize the Warranty Landing Page JS Module
 */

var processInclude = require('./components/processInclude');

$(document).ready(function () {
    processInclude(require('./warranty/warrantyLandingPage'));
    processInclude(require('int_warranty/warranty/warrantyLandingPage'));
});
